import { render, staticRenderFns } from "./MyChart.vue?vue&type=template&id=61cba250&scoped=true&"
import script from "./MyChart.vue?vue&type=script&lang=js&"
export * from "./MyChart.vue?vue&type=script&lang=js&"
import style0 from "./MyChart.vue?vue&type=style&index=0&id=61cba250&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cba250",
  null
  
)

export default component.exports